import {
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';
import { migrateSections } from '../sections/migration';

// Get all pages for a project
export async function getProjectPages(projectId) {
  const pagesRef = collection(db, 'projects', projectId, 'pages');
  const q = query(pagesRef, orderBy('order', 'asc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => {
    const data = doc.data();
    return {
      id: doc.id,
      ...data,
      // Migrate sections to current schema version
      sections: migrateSections(data.sections || [])
    };
  });
}

// Get a single page
export async function getPage(projectId, pageId) {
  const docRef = doc(db, 'projects', projectId, 'pages', pageId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const data = docSnap.data();
    return {
      id: docSnap.id,
      ...data,
      sections: migrateSections(data.sections || [])
    };
  }
  return null;
}

// Create a new page
export async function createPage(projectId, data) {
  const pagesRef = collection(db, 'projects', projectId, 'pages');
  const pageData = {
    name: data.name || 'Новая страница',
    slug: data.slug || 'new-page',
    sections: data.sections || [],
    order: data.order || 0,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };
  const docRef = await addDoc(pagesRef, pageData);
  return { id: docRef.id, ...pageData };
}

// Update page content (sections)
export async function updatePage(projectId, pageId, data) {
  const docRef = doc(db, 'projects', projectId, 'pages', pageId);
  await updateDoc(docRef, {
    ...data,
    updatedAt: serverTimestamp()
  });
}

// Delete a page
export async function deletePage(projectId, pageId) {
  const docRef = doc(db, 'projects', projectId, 'pages', pageId);
  await deleteDoc(docRef);
}

// Save page sections (from page builder)
export async function savePageSections(projectId, pageId, sections) {
  const docRef = doc(db, 'projects', projectId, 'pages', pageId);
  await updateDoc(docRef, {
    sections,
    updatedAt: serverTimestamp()
  });
}
